import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({
    brand_name: 'Oexams',
    tagline: 'Smart Exams for Smart Teachers',
    logo_path: ''
  });

  useEffect(() => {
    loadSettings();
    const token = localStorage.getItem('token');
    if (token) {
      API.get('/auth/me')
        .then(r => {
          const u = { ...r.data.user, name: r.data.user.full_name };
          setUser(u);
          setSubscription(r.data.subscription);
        })
        .catch(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loadSettings = async () => {
    try {
      const r = await API.get('/admin/settings');
      setSettings(r.data);
    } catch {}
  };

  // Regular teacher/school login
  const login = async (phone, password) => {
    const r = await API.post('/auth/login', { phone, password });
    localStorage.setItem('token', r.data.token);
    const u = { ...r.data.user, name: r.data.user.name || r.data.user.full_name };
    localStorage.setItem('user', JSON.stringify(u));
    setUser(u);
    try {
      const me = await API.get('/auth/me');
      const fullUser = { ...me.data.user, name: me.data.user.full_name };
      setUser(fullUser);
      setSubscription(me.data.subscription);
      return fullUser;
    } catch {
      return u;
    }
  };

  // Admin login — sets user in context FIRST, then navigates
  const adminLogin = async (phone, password) => {
    const r = await API.post('/auth/admin-login', { phone, password });
    localStorage.setItem('token', r.data.token);
    const u = { ...r.data.user, name: r.data.user.full_name };
    localStorage.setItem('user', JSON.stringify(u));
    // Set user in context immediately before any navigation
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setSubscription(null);
    window.location.replace('/#/login');
  };

  const refreshUser = async () => {
    const r = await API.get('/auth/me');
    const u = { ...r.data.user, name: r.data.user.full_name };
    setUser(u);
    setSubscription(r.data.subscription);
  };

  return (
    <AuthContext.Provider value={{ user, subscription, loading, settings, login, adminLogin, logout, refreshUser, loadSettings }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
